export default __webpack_public_path__ + "static/media/OverStock.1fc9c6d8.svg";